

import {Map} from 'mapbox-gl';
import { defineComponent } from 'vue';

export default defineComponent({
  
  props: {
    location: {
      type: String,
      required: true,
    },
    map: {
      type: Map,
      required: true,
    },
    overlayUrl: {
      type: String,
      require: true,
    },
    pollutant: {
      type: String,
      required: true,
    },

    bounds: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sourceIds: [],
      layerIds: [],
    };
  },

  methods: {
    /**
     * Add the hyperlocal (street level) overlay.
     */
    addLayer() {

      const groups = [
        {id: 'G5', minzoom: 11},
        {id: 'G4', minzoom: 10},
        {id: 'G3', minzoom: 10},
        {id: 'G2', minzoom: 8},
        {id: 'G1', minzoom: 8},
      ];

      groups.forEach((group) => {
        const {id, minzoom} = group;
        const sourceId = `${this.location}-${id}`;

        if (!this.map.getSource(sourceId))
          this.map.addSource(sourceId, {
            type: 'vector',
            tiles: [`${this.overlayUrl}/${id}/{z}/{x}/{y}.pbf`],
            scheme: 'xyz',
            minzoom,
            maxzoom: 12,
            bounds: this.bounds.split(',').map((s) => parseFloat(s)),
          });

        if (!this.map.getLayer(sourceId))
          this.map.addLayer(
            {
              id: sourceId,
              type: 'line',
              source: sourceId,
              'source-layer': this.location,
              paint: {
                // line-width evolves with zoom level to have a good looking map
                // negative width value at high zoom to have a more linear apparition
                'line-width': [
                  'interpolate',
                  ['linear'],
                  ['zoom'],
                  8,
                  [
                    'match',
                    ['get', 'w'],
                    [23, 99, 22, 21, 20],
                    -2,
                    [19, 18, 17],
                    -1,
                    [16, 15, 14, 13, 12, 11, 10],
                    0,
                    -1,
                  ],
                  24,
                  [
                    'match',
                    ['get', 'w'],
                    [23, 99, 22, 21, 20],
                    12,
                    [19, 18, 17],
                    15,
                    [16, 15, 14, 13, 12, 11, 10],
                    18,
                    15,
                  ],
                ],
                /* line-color need to change dynamically according to the selection in the interface
                (see description of color variable at the top of the page) */
                'line-color': ['get', this.pollutant],
                'line-blur': 0.5,
              },
              layout: {
                'line-cap': 'round',
                'line-join': 'round',
              },
            },
            // for the tiles order, the model is below this mapbox layer
            'settlement-subdivision-label',
          );

        this.sourceIds.push(sourceId);
        this.layerIds.push(sourceId);
      });
    },

    removeLayer() {
      const {map} = this;

      this.layerIds.forEach(
        (layerId) => map.getLayer(layerId) && this.map.removeLayer(layerId),
      );
      this.sourceIds.forEach(
        (sourceId) => this.map.getSource(sourceId) && this.map.removeSource(sourceId),
      );

      this.sourceIds = [];
      this.layerIds = [];
    },
  },

  watch: {
    pollutant: {
      immediate: true,
      handler() {
        this.removeLayer();
        this.addLayer();
      },
    },
  },

  mounted() {
    // const {this.map} = this;
    this.addLayer();
  },

  beforeDestroy() {
    this.removeLayer();
  },
});
